import { Box, Button, Dialog, DialogContent, IconButton, Radio, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { getNiceTimestamp } from 'src/utils/get-nice-timestamp';

const SelectSchedulerModal = ({open, onClose, onSelectScheduler}) => {
    const { schedulers } = useSelector((state) => state.Scheduler)

    const [selectedScheduler, setSelectedScheduler] = useState('')

    const handleClose = () => {
        setSelectedScheduler('')
        onClose()
    }

    const handleSelectScheduler = () => {
        if(selectedScheduler){
            onSelectScheduler(selectedScheduler)
            onClose()
        }
    }

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={open}
            onClose={handleClose}
            >
                {/* <DialogContent> */}
                    {/* <Box sx={{
                        position: "relative",
                        height: "300px"
                    }}>
                        <Box sx={{
                            position: 'fixed',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "10px"
                        }}>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "baseline",
                            mb: 2,
                        }}>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "baseline"
                            }}>
                                <TextField label={"Search"} variant="standard" sx={{
                                    minWidth: "300px"
                                }} />
                                <IconButton>
                                    <SearchIcon color="primary" fontSize="small" />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box> */}
                    <Table stickyHeader>
                        <TableHead>
                            {/* <TableRow>
                                <TableCell colSpan={3}>
                                    <TextField label={"Search"} variant="standard" sx={{
                                        minWidth: "300px"
                                    }} />
                                    <IconButton>
                                        <SearchIcon color="primary" fontSize="small" />
                                    </IconButton>
                                </TableCell>
                                <TableCell><Button size='small' variant='contained' disabled={selectedPlaylist ? false : true} onClick={handleSelectPlaylist}>Select</Button></TableCell>
                            </TableRow> */}
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: "baseline"
                                    }}>
                                        <TextField label={"Search"} variant="standard" sx={{
                                            minWidth: "300px"
                                        }} />
                                        <IconButton>
                                            <SearchIcon color="primary" fontSize="small" />
                                        </IconButton>
                                    </Box>
                                </TableCell>
                                <TableCell align="right" colSpan={2}>
                                    <Button size='small' variant='contained' sx={{mr: 2}} disabled={selectedScheduler ? false : true} onClick={handleSelectScheduler}>Select</Button>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {schedulers.map(sch => {
                                return (
                                    <TableRow hover key={sch._id}>
                                        <TableCell>
                                            <Radio name='playlistSelect' onChange={() => setSelectedScheduler(sch)} checked={selectedScheduler._id == sch._id} value={sch._id} sx={{
                                                color: sch.color,
                                                '&.Mui-checked': {
                                                    color: sch.color,
                                                },
                                            }} />
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title={sch.name.length > 30 ? sch.name : ''} placement="right">
                                            <Typography variant="subtitle2">
                                                {sch.name.length > 30 ? `${sch.name.slice(0, 30)}...` : sch.name}
                                            </Typography>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">
                                            {getNiceTimestamp(new Date(sch?.createdAt?.toString()))}
                                        </TableCell>
                                        <TableCell align="right">
                                            {/* <Typography variant="button">
                                            {playlist?.defaultPlaylist ? (
                                                'demo'
                                            ) : '-'}
                                            </Typography> */}
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                {/* </DialogContent> */}
        </Dialog>
    )
}

export default SelectSchedulerModal
